export default __webpack_public_path__ + "static/media/3.2ae6c481.png";